
import { useEffect } from 'react';
import { useDispatch } from './redux/store';
import { useIndexedDB } from "react-indexed-db-hook";
import tournamentParticipantsCrud from './redux/slices/tournament-participants';

export default function Sync() {
    const dispatch = useDispatch();

    const { getByIndex: getVote, update: updateVote } = useIndexedDB("votes");

    useEffect(() => {
        const interval = setInterval(async () => {
            const vote = await getVote('status', 'ready')
            if(!vote){
                return
            }

            dispatch(tournamentParticipantsCrud.saveItem({
                ...vote.vote,
                id_tournament_participant: vote.id_tournament_participant,
                version: vote.timestamp,
                comments: vote.comments,
                profile: vote.profile,
            })).then((payload) => {
                if(payload?.payload?.id){
                    updateVote({
                        ...vote,
                        status: 'synchronized',
                        synchronized: payload?.payload?.id
                    })
                }
            })
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (<></>)
}
